import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

const StyledIntegrationsDashboard = styled.div`
  width: 100%;
  height: calc(100%-80px);
  padding: 40px;
  margin-top: 10px;
`;

const IntegrationsDashboard = () => {
  return (
    <StyledIntegrationsDashboard data-testid="integrations-dashboard-view">
      <Outlet />
    </StyledIntegrationsDashboard>
  );
};

export default IntegrationsDashboard;
